// store/slices/itemsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchCategories = createAsyncThunk(
  'peitems/fetchCategories',
  async () => {
    const response = await axios.get(`${API_BASE_URL}/dropdown/mcatdrop`);
    return response.data;
  }
);

export const fetchItems = createAsyncThunk(
  'peitems/fetchItems',
  async () => {
    const response = await axios.get(`${API_BASE_URL}/dropdown/mitemdrop`);
    return response.data;
  }
);

export const fetchIndentItems = createAsyncThunk(
  'peitems/fetchIndentItems',
  async (indentId) => {
    const response = await axios.get(`${API_BASE_URL}/viewTable/indentitems`, {
      params: { indentId }
    });
    return response.data;
  }
);

const peitemsSlice = createSlice({
  name: 'peitems',
  initialState: {
    categories: [],
    allItems: [],
    indentItems: [],
    loading: {
      categories: false,
      items: false,
      indentItems: false
    },
    error: null,
    selectedCategory: null,
    selectedItem: null
  },
  reducers: {
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    setSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
    },
    addIndentItem: (state, action) => {
      state.indentItems.push(action.payload);
    },
    updateIndentItem: (state, action) => {
      const index = state.indentItems.findIndex(item => item.indentItemID === action.payload.indentItemID);
      if (index !== -1) {
        state.indentItems[index] = action.payload;
      }
    },
    removeIndentItem: (state, action) => {
      state.indentItems = state.indentItems.filter(item => item.indentItemID !== action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading.categories = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading.categories = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading.categories = false;
        state.error = action.error.message;
      })
      // Add similar cases for fetchItems and fetchIndentItems
  }
});

export const { 
  setSelectedCategory, 
  setSelectedItem, 
  addIndentItem, 
  updateIndentItem, 
  removeIndentItem 
} = peitemsSlice.actions;

export default peitemsSlice.reducer;